/* eslint-disable func-call-spacing */
import Vue from 'vue'
import Router from 'vue-router'

import MainRoutes from '~pages/routes'
import AuthRoutes from '~pages/Auth/routes'
import DashboardsRoutes from '~pages/Dashboards/routes'
import CustomReportsRoutes from '~src/customReports/routes'

import InitialLoading from '~components/InitialLoading.vue'

import _ from 'lodash'

Vue.use(Router)

const InitRouters = [
  {
    path: '*',
    redirect: '/projects'
  },
  {
    path: '/',
    redirect: '/projects'
  },
  {
    name: 'initialLoading',
    path: '/loading-cache',
    components: {
      default: InitialLoading
    },
    meta: {
      bypassToken: true
    }
  }
]

export const router = new Router({
  mode: 'history',
  routes: _.concat(InitRouters, MainRoutes, AuthRoutes, DashboardsRoutes, CustomReportsRoutes)
})
